.action {
  padding: 5px;
  display: flex;
  align-items: center;
}

.action:not(.disabled):hover {
  background-color: var(--hover-light);
  cursor: pointer;
}

.action svg {
  width: 1.3rem;
}

.title {
  padding-left: 5px;
  white-space: nowrap;
}

.action.disabled {
  fill: var(--main-text-disabled);
  color: var(--main-text-disabled);
}

.action.active {
  background-color: var(--button-border-disabled);
}
